export enum WarningMessage {
  TWAMP_WARNING_MESSAGE = 'Test will be queued/failed.All twamp test resources are currently in use',
  SERVICE_WARNING_MESSAGE = 'Test will be queued/failed.All service test resources are currently in use',
  VOIP_WARNING_MESSAGE = 'Test will be queued/failed.All voip test resources are currently in use',
  TRUESPEED_WARNING_MESSAGE = 'Test will be queued/failed.All truespeed test resources are currently in use',
  MULTISTEP_WARNING_MESSAGE = 'Test will be queued/failed.All multistep test resources are currently in use',
  Y1564_WARNING_MESSAGE = 'Test will be queued/failed.All y1564 test resources are currently in use',
  BERT_WARNING_MESSAGE = 'Test will be queued/failed.All bert test resources are currently in use',
  Y1731_WARNING_MESSAGE = 'Test will be queued/failed.All y1731 test resources are currently in use',
  RFC2544_WARNING_MESSAGE = 'Test will be queued/failed.All rfc2544 test resources are currently in use',
  UDP_WARNING_MESSAGE = 'Test will be queued/failed.All udp test resources are currently in use',
  HTTP_WARNING_MESSAGE = 'Test will be queued/failed.All http test resources are currently in use',
  FTP_WARNING_MESSAGE = 'Test will be queued/failed.All ftp test resources are currently in use',
  RESOURCE_AVAILABLE_WARNING_MESSAGE = 'Resources Available. Ready for test',
  ALL_TEST_WARNING_MESSAGE = 'Test will be queued/failed.All test resources are in use'
}
export interface ITestQueueStatus {
  twamp: ITestQueueCount;
  voip: ITestQueueCount;
  service: ITestQueueCount;
  truespeed?: ITestQueueCount;
  multistep: ITestQueueCount;
  y1564: ITestQueueCount;
  bert: ITestQueueCount;
  y1731?: ITestQueueCount;
  rfc2544?: ITestQueueCount;
  udp?: ITestQueueCount;
  http?: ITestQueueCount;
  ftp?: ITestQueueCount;
  maxCount: number;
  overall_percentage: number;
  overall_total_used: number;
}

export interface ITestQueueCount {
  total: number;
  used: number;
  percentage?: number;
}
